import TxtBox from '../TxtBox/TxtBox';

const TextAndImageElement = ({ image, title, text, side }) => {
  return (
    <TxtBox
      imageRef={image}
      title={title}
      text={text}
      rightSide={side}
      alt={image.alt}
    />
  );
};

export default TextAndImageElement;
